// Route definitions with clientUuid parameter for React Router
export const RoutesPath = {
  ALL: '*',
  ROOT: '/',
  // Authentication routes
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  SELECT_WORKSPACE: '/select-workspace',
  RESET_PASSWORD: '/reset-password',
  CREATE_PASSWORD: '/create-password',
  NO_ACCESS: '/no-access',
  // Main application routes (with clientUuid)
  BRAND_LIBRARY: '/:clientUuid/brand-library',
  WORKSPACE: '/:clientUuid/workspace',
  MANAGE_TEAM: '/:clientUuid/manage-team',
  INTEGRATIONS: '/:clientUuid/integrations',
};

// Route paths without clientUuid for programmatic navigation
export const AppRoutes = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  SELECT_WORKSPACE: '/select-workspace',
  RESET_PASSWORD: '/reset-password',
  CREATE_PASSWORD: '/create-password',
  NO_ACCESS: '/no-access',
  BRAND_LIBRARY: '/brand-library',
  WORKSPACE: '/workspace',
  MANAGE_TEAM: '/manage-team',
  INTEGRATIONS: '/integrations',
};

export const NON_CLIENT_ROUTES = [
  RoutesPath.ALL,
  RoutesPath.ROOT,
  RoutesPath.LOGIN,
  RoutesPath.FORGOT_PASSWORD,
  RoutesPath.SELECT_WORKSPACE,
  RoutesPath.RESET_PASSWORD,
  RoutesPath.CREATE_PASSWORD,
  RoutesPath.NO_ACCESS,
];
